import { ASYNC_TYPES, PURE } from '@travel-frontend/state-handling-sdk';
import axios from 'axios';
import Cookies from 'js-cookie';
import { ALIAS_EMAIL, ALIAS_TOKEN, CHECK_TOKEN, CREATE_PASSWORD, DO_LOGIN, DO_LOGOUT, DO_REGISTER, FORGOT_PASSWORD, GET_PROFILE_DATA, GET_STATUS, IS_SERVICE_AGENT, MIGRATE_ACCOUNT, NEW_PASSWORD, REFRESH_TOKEN, RESEND_VERIFICATION, RESET_ERRORS, SET_TOKEN, TOGGLE_COMPONENT, VERIFY_CUSTOMER } from '../../../components/Authentication/redux/models.js';
export function doLogin(authUrl, credentials, onSuccess, onFail) {
  return {
    types: ASYNC_TYPES(DO_LOGIN),
    callAPI: async () => {
      try {
        const response = await axios.post(`${authUrl}/login/traditional`, {
          emailAddress: credentials?.emailAddress,
          password: credentials?.password
        });
        localStorage.setItem(ALIAS_EMAIL, credentials.emailAddress);
        Cookies.remove(IS_SERVICE_AGENT);
        Cookies.set(ALIAS_TOKEN, response.data.value, {
          expires: new Date(response.data.expiresAt)
        });
        if (onSuccess) {
          onSuccess();
        }
        return {
          expiresAt: response.data.expiresAt,
          aliasToken: response.data.value
        };
      } catch (error) {
        if (onFail && error?.response?.data.errorType === 'migrated-customer') {
          onFail();
        }
        throw error;
      }
    }
  };
}
export function forgotPassword(authUrl, emailAddress, onSuccess, onFail) {
  return {
    types: ASYNC_TYPES(FORGOT_PASSWORD),
    callAPI: async () => {
      try {
        await axios.post(`${authUrl}/password-forget/start`, {
          emailAddress
        });
        if (onSuccess) {
          onSuccess();
        }
      } catch (error) {
        if (onFail) {
          onFail();
        }
        throw error;
      }
    }
  };
}
export function refreshToken(authUrl, onFail) {
  return {
    types: ASYNC_TYPES(REFRESH_TOKEN),
    callAPI: async () => {
      try {
        const response = await axios.post(`${authUrl}/login/refresh`, null, {
          headers: {
            'X-Authorization': `Bearer ${Cookies.get(ALIAS_TOKEN)}`
          }
        });
        Cookies.remove(ALIAS_TOKEN);
        Cookies.set(ALIAS_TOKEN, response.data.value, {
          expires: new Date(response.data.expiresAt)
        });
        return {
          expiresAt: response.data.expiresAt,
          aliasToken: response.data.value
        };
      } catch (error) {
        if (onFail) {
          onFail();
        }
        throw error;
      }
    }
  };
}
export function checkToken(authUrl, token, onFail) {
  return {
    types: ASYNC_TYPES(CHECK_TOKEN),
    callAPI: async () => {
      try {
        await axios.post(`${authUrl}/password-forget/check-token`, {
          token
        }, {
          headers: {
            'X-Authorization': `Bearer ${Cookies.get(ALIAS_TOKEN)}`
          }
        });
      } catch (error) {
        if (onFail) {
          onFail();
        }
        throw error;
      }
    }
  };
}
export function doLogout() {
  localStorage.removeItem(ALIAS_EMAIL);
  Cookies.remove(ALIAS_TOKEN);
  Cookies.remove(IS_SERVICE_AGENT);
  return {
    type: PURE(DO_LOGOUT)
  };
}
export function resetErrors() {
  return {
    type: PURE(RESET_ERRORS)
  };
}
export function verifyCustomer(authUrl, verificationToken, onFail) {
  return {
    types: ASYNC_TYPES(VERIFY_CUSTOMER),
    callAPI: async () => {
      try {
        await axios.post(`${authUrl}/register/verify-customer`, {
          verificationToken
        });
      } catch (error) {
        if (onFail) {
          onFail();
        }
        throw error;
      }
    }
  };
}
export function doRegister(authUrl, credentials, onSuccess, onFail) {
  return {
    types: ASYNC_TYPES(DO_REGISTER),
    callAPI: async () => {
      try {
        await axios.post(`${authUrl}/register`, {
          emailAddress: credentials?.emailAddress,
          firstName: credentials?.firstName,
          gender: credentials?.salutation,
          lastName: credentials?.lastName,
          password: credentials?.password
        });
        if (onSuccess) {
          onSuccess();
        }
      } catch (error) {
        if (onFail) {
          onFail();
        }
        throw error;
      }
    }
  };
}
export function createPassword(authUrl, password, onFail) {
  return {
    types: ASYNC_TYPES(CREATE_PASSWORD),
    callAPI: async () => {
      try {
        await axios.post(`${authUrl}/create-password`, {
          password
        });
      } catch (error) {
        if (onFail) {
          onFail();
        }
        throw error;
      }
    }
  };
}
export function resendVerification(authUrl, emailAddress, onFail) {
  return {
    types: ASYNC_TYPES(RESEND_VERIFICATION),
    callAPI: async () => {
      try {
        await axios.post(`${authUrl}/register/restart-verification`, {
          emailAddress
        });
      } catch (error) {
        if (onFail) {
          onFail();
        }
        throw error;
      }
    }
  };
}
export function setNewPassword(authUrl, newPassword, token, onFail) {
  return {
    types: ASYNC_TYPES(NEW_PASSWORD),
    callAPI: async () => {
      try {
        await axios.post(`${authUrl}/password-forget/set`, {
          newPassword,
          token
        });
      } catch (error) {
        if (onFail) {
          onFail();
        }
        throw error;
      }
    }
  };
}
export function migrateAccount(authUrl, emailAddress, onFail) {
  return {
    types: ASYNC_TYPES(MIGRATE_ACCOUNT),
    callAPI: async () => {
      try {
        await axios.post(`${authUrl}/password-forget/start`, {
          emailAddress
        });
      } catch (error) {
        if (onFail) {
          onFail();
        }
        throw error;
      }
    }
  };
}
export function getUserStatus(authUrl) {
  return {
    types: ASYNC_TYPES(GET_STATUS),
    callAPI: async () => {
      const response = await axios.get(`${authUrl}/login/status`, {
        headers: {
          'X-Authorization': `Bearer ${Cookies.get(ALIAS_TOKEN)}`
        }
      });
      return response.data;
    }
  };
}
export function getProfileInfo(authUrl) {
  return {
    types: ASYNC_TYPES(GET_PROFILE_DATA),
    callAPI: async () => {
      const response = await axios.get(`${authUrl}/profile-data`, {
        headers: {
          'X-Authorization': `Bearer ${Cookies.get(ALIAS_TOKEN)}`
        }
      });
      return response.data;
    }
  };
}
export function setToken(token) {
  const config = {
    expires: new Date(Date.now() + 60 * 60 * 1000) // one hour
  };
  Cookies.set(ALIAS_TOKEN, token, config);
  Cookies.set(IS_SERVICE_AGENT, 'true', config);
  return {
    type: PURE(SET_TOKEN)
  };
}
export function toggleComponent(componentType, component) {
  return {
    type: PURE(TOGGLE_COMPONENT),
    componentType,
    component
  };
}